  
export const enguanyAnyVinent = () =>
{

  const enguany = new Date().getFullYear()
  let anyVinent = enguany + 1
  anyVinent = anyVinent.toString().slice(-2)

  return {enguany, anyVinent}
}

// variants d'un mateix curs (p.ex. Batxillerat: antic/tecnologic/cientific/humanistic/social/repetidors),
// mateix conveni de sufixos que ja fa servir formelements.js per emparellar cursObligatori
const SUFIXOS_CURS = ['', 'A', 'T', 'C', 'H', 'S', 'R']

export const trobaCursPerCodi = (families, codiCurs) => {

  if (!codiCurs || !families) return undefined

  for (const cicle of Object.values(families)) {
    if (!cicle?.families) continue
    for (const familia of cicle.families) {
      for (const curs of (familia.cursos || [])) {
        if (SUFIXOS_CURS.some(sufix => curs.id === codiCurs + sufix)) return curs
      }
    }
  }

  return undefined
}